module.exports = __webpack_public_path__ + "img/022.7482efe1.png";